import React, { useState } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import CustomButton from "../../components/CustomButton";
import { icons } from "../../assets/icons";
import { useNavigate } from "react-router-dom";
import SelectInput from "../../components/FormFields/SelectInput";
import AllVouchers from "../../components/Vouchers/AllVouchers";
import { useAuth } from "../../contexts/AuthContext";
import { useMediaQuery } from "react-responsive";
import UploadReports from "./UploadReports";
import ReworkHistory from "../../components/Vouchers/ReworkHistory";
import DownloadVoucher from "../../../srcWeb/components/Vouchers/DownloadVoucher";

const Vouchers = () => {
  const isMobileSmall = useMediaQuery({ query: "(max-width: 336px)" });
  const navigate = useNavigate();
  const onClickSubmitVouchers = () => {
    navigate("/vouchers/submit", { state: { isEditFeatureOn: false } });
  };

  const { currentTabSelect, user: { userLabel = "" } = {} } = useAuth();

  // console.log(" - - -- - - -- - ", currentTabSelect, userLabel);

  const stateOfVoucherValue = (key) => {
    switch (key) {
      case 1:
        return "";
      case 2:
        return "PENDING";
      case 3:
        return "APPROVED";
      case 4:
        return "REJECTED";
      case 5:
        return "SAVED";
      default:
        return "";
    }
  };
  const [status, setStatus] = useState("");

  const nonStoreFinanceOptions = [
    { key: "View All Voucher", value: "" },
    { key: "View Pending Voucher", value: "PENDING" },
    { key: "View Approved Voucher", value: "APPROVED" },
    { key: "View Rejected Voucher", value: "REJECTED" },
    { key: "Rework pending", value: "REWORK" },
    { key: "View Download Voucher", value: "DOWNLOAD" },
    { key: "Upload Reports", value: "REPORT" },
  ];
  const nonStoreOptions = [
    { key: "View All Voucher", value: "" },
    { key: "View Pending Voucher", value: "PENDING" },
    { key: "View Approved Voucher", value: "APPROVED" },
    { key: "View Rejected Voucher", value: "REJECTED" },
    { key: "Rework pending", value: "REWORK" },
  ];
  const storeOptions = [
    { key: "View All Voucher", value: "" },
    { key: "View Pending Voucher", value: "PENDING" },
    { key: "View Approved Voucher", value: "APPROVED" },
    { key: "View Rejected Voucher", value: "REJECTED" },
    { key: "View Saved Vouchers", value: "SAVED" },
    { key: "Rework pending", value: "REWORK" },
  ];

  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Vouchers"
        showBack={false}
        containerClassName="mt-14"
        textClassCss={isMobileSmall ? "text-[2.5rem]" : "text-[3rem]"}
        renderRight={() => {
          if (userLabel === "Store")
            return (
              <CustomButton
                title="Submit Voucher"
                icon={icons.plusIcon}
                textClassName={isMobileSmall ? "text-[1.4rem]" : "text-[1.5rem]"}
                onClick={onClickSubmitVouchers}
              />
            );
        }}
        showStores
      />

      <SelectInput
        options={userLabel === "Store" ? storeOptions : userLabel === "Finance" ? nonStoreFinanceOptions : nonStoreOptions}
        onChange={(e) => {
          setStatus(e);
        }}
        value={
          status || status === ""
            ? (userLabel === "Store" ? storeOptions : userLabel === "Finance" ? nonStoreFinanceOptions : nonStoreOptions).find((it) => it.value === status)
            : {
                key: currentTabSelect.title,
                value: stateOfVoucherValue(currentTabSelect.id),
              }
        }
      />
      {status !== "REPORT" && status !== "REWORK" && status !== "DOWNLOAD" && <AllVouchers status={status} />}
      {status === "REPORT" && (
        <div className="mt-8">
          <UploadReports />
        </div>
      )}
      {status === "REWORK" && (
        <div className="mt-8">
          <ReworkHistory />
        </div>
      )}
      {status === "DOWNLOAD" && (
        <div className="mt-8">
          <DownloadVoucher />
        </div>
      )}

      {/* <WrapperWithTabs
        tabBarOptions={tabBarOptions}
        commonProps={{ title: "Hi" }}
        componentBasedProps={{ 1: { subTitle: "Hello" } }}
        wrapperClassName="mt-12"
      /> */}
    </div>
  );
};

export default Vouchers;
